import { Route, Routes } from "react-router-dom";
import { ClinicalCardsIndex } from "../../features/clinical-cards/ClinicalCardsIndex";
import { AcuteAbdomenWorkspace } from "../../features/clinical-cards/acute-abdomen/AcuteAbdomenWorkspace";
import { SepsisEarlyRecognitionWorkspace } from "../../features/clinical-cards/sepsis/SepsisEarlyRecognitionWorkspace";
import { LegacyHome } from "../../features/home/LegacyHome";
import { InteractiveCasesIndex } from "../../features/interactive-cases/InteractiveCasesIndex";
import { AlteredConsciousnessCase } from "../../features/interactive-cases/altered-consciousness/AlteredConsciousnessCase";
import { FluidElectrolyteModule } from "../../features/learning-modules/FluidElectrolyteModule";
import { LearningModulesIndex } from "../../features/learning-modules/LearningModulesIndex";
import { PlaceholderPage } from "../../features/shared/PlaceholderPage";
import { SourceClonePage } from "../../features/source-clone/SourceClonePage";

export function AppRoutes() {
  return <Routes>
    <Route path="/" element={<LegacyHome />} />
    <Route path="/vaka-ile-ogren" element={<InteractiveCasesIndex />} />
    <Route path="/vaka-ile-ogren/bilinc-degisikligi-ilk-10-dakika" element={<AlteredConsciousnessCase />} />
    <Route path="/klinik-kartlar" element={<ClinicalCardsIndex />} />
    <Route path="/klinik-kartlar/cocukluk-caginda-akut-karin-cerrahi-aciller" element={<AcuteAbdomenWorkspace />} />
    <Route path="/klinik-kartlar/cocukta-sepsisin-erken-taninmasi" element={<SepsisEarlyRecognitionWorkspace />} />
    <Route path="/egitim-modulleri" element={<LearningModulesIndex />} />
    <Route path="/egitim-modulleri/cocuklarda-sivi-elektrolit-tedavisi" element={<FluidElectrolyteModule />} />
    <Route path="/arama" element={<PlaceholderPage title="İçerik Ara" />} />
    <Route path="*" element={<SourceClonePage />} />
  </Routes>;
}
